var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.titleWidget
        ? _c("h3", { staticClass: "text-center title-widget-package" }, [
            _vm._v(_vm._s(_vm.titleWidget))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.canRender
        ? _c("ae-package-list", {
            class: { "aedw-package-list-default-grid": _vm.useDefaultGridCols },
            attrs: {
              show_in_carroussel_mobile: _vm.show_in_carroussel_mobile,
              show_in_carroussel_desktop: _vm.show_in_carroussel_desktop,
              use_location_unit_selector: _vm.use_location_unit_selector,
              use_multi_widgets: _vm.use_multi_widgets
            },
            domProps: {
              posId: _vm.posId,
              config: _vm.config,
              template: _vm.templateName,
              params: _vm.params,
              disableGetPackagesOnRender: _vm.disableGetPackagesOnRender,
              location_unit_selector_params: _vm.location_unit_selector_params,
              multi_widgets_params: _vm.multi_widgets_params,
              paramsFilterRequestPOS: _vm.paramsFilterRequestPOS,
              bonusStripColor: _vm.bonusStripColor,
              showinstallmentsLabel: _vm.showinstallmentsLabel,
              showIconsWithInformation: _vm.showIconsWithInformation
            },
            on: { toCheckout: _vm.toCheckout }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }